// extracted by mini-css-extract-plugin
module.exports = {"root":"signup-view_root__0YIGB","header":"signup-view_header__tJd0K"};